import { render, staticRenderFns } from "./ExternalTicketUpdateItem.vue?vue&type=template&id=f2ae99f4&"
import script from "./ExternalTicketUpdateItem.vue?vue&type=script&lang=js&"
export * from "./ExternalTicketUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports